<template>
  <div>
    <div v-if="address">
      <p v-if="!!name" style="font-size: 16px; margin-bottom: 0">
        {{ name }}
      </p>
      <p v-if="!!poBox" style="font-size: 16px; margin-bottom: 0">
        {{ poBox }}
      </p>
      <p v-if="!!street" style="font-size: 16px; margin-bottom: 0">
        {{ street }}
      </p>
      <p v-if="!!street2" style="font-size: 16px; margin-bottom: 0">
        {{ street2 }}
      </p>
      <p v-if="!!street3" style="font-size: 16px; margin-bottom: 0">
        {{ street3 }}
      </p>
      <p v-if="!!street4" style="font-size: 16px; margin-bottom: 0">
        {{ street4 }}
      </p>
      <p style="font-size: 16px; margin-bottom: 0">{{ zip }} {{ city }}</p>
      <p v-if="!!country" style="font-size: 16px; margin-bottom: 0">
        {{ country }}
      </p>
      <MapModal v-if="address && showMap" :value="address" />
    </div>
    <p v-else>-</p>
  </div>
</template>

<script>
import { saveGet } from '@/mixins/saveGet'
import MapModal from './MapModal.vue'

export default {
  name: 'Address',
  components: { MapModal },
  props: ['address', 'showMap'],
  mixins: [saveGet],
  computed: {
    name() {
      return this.saveGet(this.address, '', 'postalName', 'value')
    },
    poBox() {
      let val = this.saveGet(this.address, '', 'postOfficeBoxNumber')

      return val.length === 0 ? '' : this.$t('PO_Box') + ' ' + val
    },
    street() {
      return this.saveGet(this.address, '', 'streetAddress', 'value')
    },
    street2() {
      return this.saveGet(this.address, '', 'streetAddressLine2', 'value')
    },
    street3() {
      return this.saveGet(this.address, '', 'streetAddressLine3', 'value')
    },
    street4() {
      return this.saveGet(this.address, '', 'streetAddressLine4', 'value')
    },
    city() {
      let region = this.saveGet(this.address, '', 'addressRegion', 'value')

      return (
        this.saveGet(this.address, '', 'addressLocality', 'value') +
        (region ? ', ' + region : '')
      )
    },
    zip() {
      return this.saveGet(this.address, '', 'postalCode')
    },
    country() {
      let cc = this.saveGet(this.address, '', 'countryCode')

      if (cc.length !== 2) {
        return ''
      }

      return this.$t('countries.' + cc)
    }
  },
  i18n: {
    messages: {
      de: {
        PO_Box: 'Postfach'
      },
      en: {
        PO_Box: 'PO Box'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Address.vue